import React from "react";
const WarnMessageContent = () => {
    return (
        <div>
            <p>Nadaljnja uporaba se obračunana po ceniku. <a className='warn-snackbar-mail' href="mailto:info@vitasis.si">info@vitasis.si</a></p>
        </div>
    )
}

export default WarnMessageContent;